import { Modal } from "antd";
import React, { useState } from "react";
import Heading from "../../Components/Headings/MainHeading/Heading";
import Wrapper from "./index.styled";
import RightArrow from "../../images/right-arrow.svg";
import FormControl from "../../Components/FormControl/FormControl";
import OperatingLocations from "../../Components/Settings/OperatingLocations/OperatingLocations";
import { useLocation, useNavigate } from "react-router-dom";

function Settings() {
  const navigate = useNavigate();
  const [operating_modal, setOperatingModal] = useState(false);
  const [constants_modal, setConstantsModal] = useState(false);
  const [selected_option, setSelectedOption] = useState(null);
  // <Search
  //             placeholder="Search"
  //             // onFocus={() => setSearchFocus(true)}
  //             // searchValue={searchValue}
  //             // onChange={handleChange}
  //           />
  return (
    <>
      <Wrapper>
        <Modal
          visible={operating_modal}
          className={`right-slide-modal w-100`}
          footer={false}
          onCancel={() => setOperatingModal(false)}
        >
          <OperatingLocations setOperatingModal={setOperatingModal} />
        </Modal>

        <div className="main_section">
          <Heading text={"Settings"} />

          <div className="body">
            <div className="options">
              <div className="category-col">
                <div className={`item`} onClick={() => setOperatingModal(true)}>
                  Operating Locations
                  <img src={RightArrow} alt="right_icon" />
                </div>
              </div>
              <div className="category-col">
                <div className={`item`} onClick={() => setConstantsModal(true)}>
                  Constants
                  <img src={RightArrow} alt="right_icon" />
                </div>
              </div>
              <div className="category-col">
                <div
                  className={`item`}
                  onClick={() => navigate("routing-schedule")}
                >
                  Routing Schedule
                  <img src={RightArrow} alt="right_icon" />
                </div>
              </div>
            </div>
            {constants_modal && (
              <div className="constants">
                <Heading text={"Constants"} style={{ marginRight: "20px" }} />

                <div className="bg-white">
                  <div className="w-60">
                    <FormControl
                      input={true}
                      placeholder={"Constant Value"}
                      labelValue={"Constant Name"}
                    />
                    <FormControl
                      input={true}
                      placeholder={"Constant Value"}
                      labelValue={"Constant Name"}
                    />
                    <FormControl
                      input={true}
                      placeholder={"Constant Value"}
                      labelValue={"Constant Name"}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Wrapper>
    </>
  );
}

export default Settings;
